import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import moment from 'moment';

import { IconStatus, ActionButton } from '../../../../../common';
import { CANCEL_OPERATION_BUTTON } from '../../../../../../helpers/data-constants';

import './editDealOperations.scss';

import UserIcon from '../../../../../../assets/icons/profile.svg';
import TimeIcon from '../../../../../../assets/icons/time.svg';

const EditDealOperations = memo(({ dataOperation, cancelOperation, clientContract, type }) => {
  const { accessRoles } = useSelector(({ user }) => user);
  let { contractId } = useParams();
  const {accessFeatures} = useSelector(({user}) => user);

  const data = { dealId: +contractId, operationId: dataOperation.id };
  const empty =
    dataOperation &&
    dataOperation?.changes &&
    dataOperation.changes.length !== 0 &&
    clientContract &&
    clientContract.positions.length !== 0;

  const prevData =
    empty &&
      dataOperation?.changes.map((item) => {
        const position = clientContract?.positions[0]
      if (item) {
        let positionData = {
          PURITY: {
            ...item,
            comment: item.previousComment,
            grossWeight: item.previousGrossWeight,
            names: item.previousNames,
            pureWeight: item.previousPureWeight,
            quantity: item.previousQuantity,
            change: 'change',
            additionalInfo: item.previousAdditionalInfo !== null ? item.previousAdditionalInfo : position.additionalInfo
          },
          THINGS: {
            ...item,
            comment: item.previousComment !== null ? item.previousComment : position.comment,
            imei: item.previousImei !== null ? item.previousImei : position.imei,
            model: item.previousModel !== null ? item.previousModel : position.model,
            names: item.previousNames !== null ? item.previousNames : position.names.join(', '),
            quantity: item.previousQuantity !== null ? item.previousQuantity : position.quantity,
            serialNumber: item.previousSerialNumber !== null ? item.previousSerialNumber : position.serialNumber,
            change: 'change',
            estimatedValue: item.previousEstimatedValue !== null ? item.previousEstimatedValue : position.estimatedValue,
            additionalInfo: item.previousAdditionalInfo !== null ? item.previousAdditionalInfo : position.additionalInfo
          },
          CARS: {
            ...item,
            names: item.previousNames !== null ? item.previousNames : position.names.join(', '),
            model: item.previousModel !== null ? item.previousModel : position.model,
            carDate: item.previousCarDate !== null ? item.previousCarDate : position.carDate,
            quantity: item.previousQuantity !== null ? item.previousQuantity : position.quantity,
            estimatedValue: item.previousEstimatedValue !== null ? item.previousEstimatedValue : position.estimatedValue,
            vin: item.newVin !== null ? item.previousVin : position.vin,
            registrationNumber: item.previousRegistrationNumber !== null ? item.previousRegistrationNumber : position.registrationNumber,
            certificateNumber: item.previousCertificateNumber !== null ? item.previousCertificateNumber : position.certificateNumber,
            certificateDate: item.previousCertificateDate !== null ? item.previousCertificateDate : position.certificateDate,
            marketPrice: item.previousMarketPrice !== null ? item.previousMarketPrice : position.marketPrice,
            storageInCashBox: item.previousStorageInCashBox !== null ? item.previousStorageInCashBox : position.storageInCashBox,
            stateOFTheVehicle: item.previousStateOFTheVehicle !== null ? item.previousStateOFTheVehicle : position.stateOFTheVehicle,
            change: 'change',
          }
        }
        return positionData[type]
      }
    })

  const newData =
    empty &&
    dataOperation?.changes.map((item) => {
      const position = clientContract?.positions[0]
      if (item) {
        let positionData = {
          PURITY: {
            ...item,
            comment: item.newComment,
            grossWeight: item.newGrossWeight,
            names: item.newNames,
            pureWeight: item.newPureWeight,
            quantity: item.newQuantity,
            change: 'change',
            additionalInfo: item.newAdditionalInfo !== null ? item.newAdditionalInfo : position.additionalInfo
          },
          THINGS: {
            ...item,
            comment: item.newComment !== null ? item.newComment : position.comment,
            imei: item.newImei !== null ? item.newImei : position.imei,
            model: item.newModel !== null ? item.newModel : position.model,
            names: item.newNames !== null ? item.newNames : position.names.join(', '),
            quantity: item.newQuantity !== null ? item.newQuantity : position.quantity,
            serialNumber:
              item.newSerialNumber !== null ? item.newSerialNumber : position.serialNumber,
            change: 'change',
            estimatedValue:
              item.newEstimatedValue !== null ? item.newEstimatedValue : position.estimatedValue,
            additionalInfo: item.newAdditionalInfo !== null ? item.newAdditionalInfo : position.additionalInfo
          },
          CARS: {
            ...item,
            names: item.newNames !== null ? item.newNames : position.names.join(', '),
            model: item.newModel !== null ? item.newModel : position.model,
            carDate: item.newCarDate !== null ? item.newCarDate : position.carDate,
            quantity: item.newQuantity !== null ? item.newQuantity : position.quantity,
            estimatedValue: item.newEstimatedValue !== null ? item.newEstimatedValue : position.estimatedValue,
            vin: item.newVin !== null ? item.newVin : position.vin,
            registrationNumber: item.newRegistrationNumber !== null ? item.newRegistrationNumber : position.registrationNumber,
            certificateNumber: item.newCertificateNumber !== null ? item.newCertificateNumber : position.certificateNumber,
            certificateDate: item.newCertificateDate !== null ? item.newCertificateDate : position.certificateDate,
            marketPrice: item.newMarketPrice !== null ? item.newMarketPrice : position.marketPrice,
            storageInCashBox: item.newStorageInCashBox !== null ? item.newStorageInCashBox : position.storageInCashBox,
            stateOFTheVehicle: item.newStateOFTheVehicle !== null ? item.newStateOFTheVehicle : position.stateOFTheVehicle,
            change: 'change',
          }
        }
        return positionData[type]
      }
      })

  return (
    <div className="contracts-timeline-item">
      <div className="contracts-timeline-item-header">
        <div className="contracts-timeline-item-header-left">
          <IconStatus status={dataOperation.type} />
        </div>
        <div className="contracts-timeline-item-user">
          {dataOperation.type !== 3 ? (
            <>
              <span className="icon">
                <UserIcon />
              </span>
              <Link className="link" to={`/user/${dataOperation.userId}`}>
                <span>{dataOperation.userFullName}</span>
              </Link>
            </>
          ) : null}
        </div>
        <div className="contracts-timeline-item-datetime">
          <span className="icon">
            <TimeIcon />
          </span>
          <span>{moment(dataOperation.date).format('DD.MM.YYYY, HH:mm:ss')}</span>
        </div>
      </div>
      <div className="contracts-timeline-item-content">
        <div className="contracts-timeline-item-content-left">
          <p>Залоговая ценность:</p>
          { type === 'PURITY' &&
            <table className="editing-history-table">
              <caption>До редактирования</caption>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Вставка</th>
                  {
                    accessFeatures['purities.additional_info'] &&
                      <th>Доп. описание</th>
                  }
                  <th>Вес, г.</th>
                  <th>Проба</th>
                  <th>Кол-во</th>
                </tr>
              </thead>
              <tbody>
                {prevData &&
                  prevData.length !== 0 &&
                  prevData.map((i, ind) => (
                    <tr key={i.names + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td><p>{i.names}</p></td>
                      <td><p>{i.comment}</p></td>
                      {
                          accessFeatures['purities.additional_info'] &&
                          <td><p>{i.additionalInfo}</p></td>
                      }
                      <td>
                        {i.grossWeight.toFixed(2)}/{i.pureWeight.toFixed(2)}
                      </td>
                      <td>
                        {i.purityType} {i.purityName}
                      </td>
                      <td>{i.quantity}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          }
          { type === 'THINGS' &&
            <table className="editing-history-table">
              <caption>До редактирования</caption>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Модель</th>
                  {
                      accessFeatures['things.additional_info'] &&
                      <th>Доп. описание</th>
                  }
                  <th>IMEI</th>
                  <th>S/N</th>
                  <th>Кол-во</th>
                  <th>Оценочная стоимость</th>
                </tr>
              </thead>
              <tbody>
                {prevData &&
                  prevData.length !== 0 &&
                  prevData.map((i, ind) => (
                    <tr key={i.names + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td><p>{i.names}</p></td>
                      <td><p>{i.model}</p></td>
                      {
                        accessFeatures['things.additional_info'] &&
                        <td><p>{i.additionalInfo}</p></td>
                      }
                      <td><p>{i.imei}</p></td>
                      <td><p>{i.serialNumber}</p></td>
                      <td>{i.quantity}</td>
                      <td><p>{i.estimatedValue}</p></td>
                    </tr>
                  ))}
              </tbody>
            </table>
          }
          { type === 'CARS' &&
            <table className="editing-history-table">
              <caption>До редактирования</caption>
              <thead>
                <tr>
                  <th>Марка</th>
                  <th>Модель</th>
                  <th>Год выпуска</th>
                  <th>Количество</th>
                  <th>Оценочная стоимость, руб.</th>
                </tr>
              </thead>
              <tbody>
                {prevData &&
                  prevData.length !== 0 &&
                  prevData.map((i, ind) => (
                    <tr key={i.names + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td>{i.names}</td>
                      <td>{i.model}</td>
                      <td>{i.carDate}</td>
                      <td>{i.quantity}</td>
                      <td><p>{i.estimatedValue}</p></td>
                    </tr>
                  ))}
                  <tr>
                    <th>VIN номер</th>
                    <th>Номер гос. регистрации</th>
                    <th>Номер свид. регистрации</th>
                    <th>Дата выдачи свид. регистрации</th>
                    <th>Рыночная стоимость руб.</th>
                  </tr>
                  {prevData &&
                  prevData.length !== 0 &&
                  prevData.map((i, ind) => (
                    <tr key={i.vin + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td><p>{i.vin}</p></td>
                      <td><p>{i.registrationNumber}</p></td>
                      <td><p>{i.certificateNumber}</p></td>
                      <td>{i.certificateDate}</td>
                      <td><p>{i.marketPrice}</p></td>
                    </tr>
                  ))}
                  <tr>
                    <th>Хранение в ломбарде</th>
                    <th colSpan={5}>Состояние ТС</th>
                  </tr>
                  {prevData &&
                  prevData.length !== 0 &&
                  prevData.map((i, ind) => (
                    <tr key={i.storageInCashBox + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td>{i.storageInCashBox ? 'C хранением в ломбарде' : 'Без хранения в ломбарде' }</td>
                      <td colSpan={5}><p>{i.stateOFTheVehicle}</p></td>
                    </tr>
                  ))}
              </tbody>
            </table>
          }
          {type === 'PURITY' &&
            <table className="editing-history-table">
              <caption>После редактирования</caption>
              <thead>
                <tr>
                  <th><p>Название</p></th>
                  <th><p>Вставка</p></th>
                    {
                      accessFeatures['purities.additional_info'] &&
                          <th>Доп. описание</th>
                    }
                  <th>Вес, г.</th>
                  <th>Проба</th>
                  <th>Кол-во</th>
                </tr>
              </thead>
              <tbody>
                {newData &&
                  newData.length !== 0 &&
                  newData.map((i, ind) => (
                    <tr
                      key={i.names + ind + i.purityName}
                      className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td><p>{i.names}</p></td>
                      <td><p>{i.comment}</p></td>
                      {
                          accessFeatures['purities.additional_info'] &&
                          <td><p>{i.additionalInfo}</p></td>
                      }
                      <td>
                        {i.grossWeight.toFixed(2)}/{i.pureWeight.toFixed(2)}
                      </td>
                      <td>
                        {i.purityType} {i.purityName}
                      </td>
                      <td>{i.quantity}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          }
          { type === 'THINGS' &&
            <table className="editing-history-table">
              <caption>После редактирования</caption>
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Модель</th>
                  {
                      accessFeatures['things.additional_info'] &&
                      <th>Доп. описание</th>
                  }
                  <th>IMEI</th>
                  <th>S/N</th>
                  <th>Кол-во</th>
                  <th>Оценочная стоимость</th>
                </tr>
              </thead>
              <tbody>
                {newData &&
                  newData.length !== 0 &&
                  newData.map((i, ind) => (
                    <tr
                      key={i.names + ind + i.serialNumber}
                      className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td><p>{i.names}</p></td>
                      <td><p>{i.model}</p></td>
                      {
                          accessFeatures['things.additional_info'] &&
                          <td>{i.additionalInfo}</td>
                      }
                      <td><p>{i.imei}</p></td>
                      <td><p>{i.serialNumber}</p></td>
                      <td>{i.quantity}</td>
                      <td><p>{i.estimatedValue}</p></td>
                    </tr>
                  ))}
              </tbody>
            </table>
          }
          { type === 'CARS' &&
            <table className="editing-history-table">
              <caption>После редактирования</caption>
              <thead>
                <tr>
                  <th>Марка</th>
                  <th>Модель</th>
                  <th>Год выпуска</th>
                  <th>Количество</th>
                  <th>Оценочная стоимость, руб.</th>
                </tr>
              </thead>
              <tbody>
                {newData &&
                  newData.length !== 0 &&
                  newData.map((i, ind) => (
                    <tr key={i.names + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td>{i.names}</td>
                      <td>{i.model}</td>
                      <td>{i.carDate}</td>
                      <td>{i.quantity}</td>
                      <td><p>{i.estimatedValue}</p></td>
                    </tr>
                  ))}
                  <tr>
                    <th>VIN номер</th>
                    <th>Номер гос. регистрации</th>
                    <th>Номер свид. регистрации</th>
                    <th>Дата выдачи свид. регистрации</th>
                    <th>Рыночная стоимость руб.</th>
                  </tr>
                  {newData &&
                  newData.length !== 0 &&
                  newData.map((i, ind) => (
                    <tr key={i.vin + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td><p>{i.vin}</p></td>
                      <td><p>{i.registrationNumber}</p></td>
                      <td><p>{i.certificateNumber}</p></td>
                      <td>{i.certificateDate}</td>
                      <td><p>{i.marketPrice}</p></td>
                    </tr>
                  ))}
                  <tr>
                    <th>Хранение в ломбарде</th>
                    <th colSpan={5} >Состояние ТС</th>
                  </tr>
                  {newData &&
                  newData.length !== 0 &&
                  newData.map((i, ind) => (
                    <tr key={i.storageInCashBox + ind} className={i.hasOwnProperty('change') ? i.change : ''}>
                      <td>{i.storageInCashBox ? 'C хранением в ломбарде' : 'Без хранения в ломбарде' }</td>
                      <td colSpan={5} >
                        <p>
                          {i.stateOFTheVehicle}
                        </p>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          }
        </div>
        <div className="contracts-timeline-item-content-right">
          {accessRoles[CANCEL_OPERATION_BUTTON] && (
            <ActionButton text="Отменить" func={cancelOperation} param={data} />
          )}
        </div>
      </div>
    </div>
  );
});

export default EditDealOperations;
